import { SB } from '@play-co/replicant';

export const conversationSchema = {
  conversation: SB.object({
    /**
     * Times each dialog was seen, keyed by species and then by dialog number (`alpaca_001` is
     * `alpaca['1']`); the client-built `want_to_add_friend_<species>` dialog has no number and is
     * `<species>.want_to_add_friend`.
     */
    dialogCounts: SB.map(SB.map(SB.int())),
    answers: SB.map(
      SB.object({
        key: SB.string().optional(),
        value: SB.string(),
      }),
    ),
  }),
};

export type Conversation = SB.ExtractType<
  typeof conversationSchema.conversation
>;

export type Answers = Conversation['answers'];
